module.exports = __webpack_public_path__ + "img/content-creation.09be8986.webp";